import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { useCallback, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import debounce from "lodash.debounce";
import { fetchMembersView, fetchMemberDetailsByHccId, fetchProviderNetworks, fetchMemberBySystemIdentifier, fetchMemberByMemberUuid, fetchAccumulatorDetails } from "../../utils/apiUtils";
import SharedTable from "../benefitPlan/SharedTable";
import Select from 'react-select';
import { AsyncPaginate } from "react-select-async-paginate";
import ReactJson from "react-json-view";
import { loadAccountHccIdentificationNumber, loadAccounts } from "../../utils/optionLoaderUtils";
import { customStyles } from "../../utils/styleUtils";
import { useNavigate } from "react-router";
import { camelCaseToWords } from "../../utils/commonUtils";

const limit = 20;

const searchOptions = ['subscriptionKey', 'subscriptionHccId', 'memberKey', 'memberHccId', 'accountKey', 'emailAddress', 'firstName', 'lastName'].map(n => ({
    value: n,
    label: camelCaseToWords(n)
}))


const Members = () => {
    const navigate = useNavigate()
    const [searchValue, setSearchValue] = useState();
    const [decouncedSearchValue, setDecouncedSearchValue] = useState();

    const [searchBy, setSearchBy] = useState(null);

    const [showMoreColumns, setShowMoreColumns] = useState(false);

    const [selectedAccounts, setSelectedAccounts] = useState([null])


    const { ref, inView } = useInView();

    const { data, error, fetchNextPage, hasNextPage, isLoading, isPending, isFetching, isFetchingNextPage, status, refetch } = useInfiniteQuery({
        queryKey: ["members-view", limit, decouncedSearchValue, selectedAccounts],
        queryFn: async ({ pageParam }) => {
            let params = pageParam || {};

            if (decouncedSearchValue && searchBy?.value) {
                params[searchBy?.value] = decouncedSearchValue;
            }
            // console.log(selectedAccounts)
            return await fetchMembersView({ ...params, limit, accountKey: selectedAccounts?.filter(f => f).at(-1)?.additional?.accountKey });
        },

        select: (data) => {
            // console.log({ data });
            return { count: data.pages?.[0]?.count, rows: data.pages.map((page) => page.rows).flatMap((x) => x) };
        },
        initialPageParam: 0,
        getNextPageParam: (lastPage, pages) => {
            const hasMore = lastPage?.rows?.length === limit;

            if (!hasMore) return undefined;
            return {
                offset: pages.reduce((accum, page) => {
                    return accum + page.rows.length;
                }, 0),
            };
        },
        staleTime: 0,
        enabled: true
    });

    useEffect(() => {
        if (inView) {
            fetchNextPage();
        }
    }, [inView]);

    const debouncedChangeHandler = useCallback(
        debounce((event) => {
            setDecouncedSearchValue(event.target.value?.trim());
        }, 500),
        []
    );

    let columns = ['subscriptionKey', 'subscriptionHccId', 'subscriberFullName', 'memberKey', 'memberHccId', 'memberFirstName', 'memberMiddleName', 'memberLastName', 'emailAddress', 'memberStatus', 'subscriberFullName', "accountKey", "versionEffDateKey",
        "versionExpDateKey"] //.sort();

    if (showMoreColumns) {
        // columns = [
        //     'memberKey',
        //     ...columns,

        // ];
        if (data?.rows) {
            const fistRow = data?.rows?.[0]

            columns = [
                ...Object.keys(fistRow).sort(),
            ];
        }
    }

    const onDetailHandler = async (body) => {

        if (!body?.memberHccId) return {}

        // const memberDetails = await fetchMemberDetailsByHccId(
        //     {
        //         "memberHccId": body?.memberHccId,
        //         "memberDetailFlags": {
        //             "includeAccount": true,
        //             "includeCob": true,
        //             "includeHeadOfHousehold": true,
        //             "includeParentAccount": true,
        //             "includeSubAccount": true,
        //             "includePlan": true,
        //             "includeProvider": true,
        //             "includeProviderPhone": true,
        //             "includeRider": true
        //         }
        //     }
        // )

        // const providerNetworks = await fetchProviderNetworks({
        //     memberHccId: body?.memberHccId,
        // })

        const [memberDetails, providerNetworks, dynamDBMembersData, accumulatorDetails] = await Promise.all([
            fetchMemberDetailsByHccId(
                {
                    "memberHccId": body?.memberHccId,
                    "memberDetailFlags": {
                        "includeAccount": true,
                        "includeCob": true,
                        "includeHeadOfHousehold": true,
                        "includeParentAccount": true,
                        "includeSubAccount": true,
                        "includePlan": true,
                        "includeProvider": true,
                        "includeProviderPhone": true,
                        "includeRider": true
                    }
                }
            ),
            fetchProviderNetworks({
                memberHccId: body?.memberHccId,
            }),
            fetchMemberBySystemIdentifier({
                systemIdentifier: body?.memberHccId?.replace('-', '#')
            }),

        ])

        let results = { ...memberDetails, providerNetworks, dynamDBMembersData }
        if (dynamDBMembersData.Items?.length) {
            const res = await fetchMemberByMemberUuid({ memberUuid: dynamDBMembersData.Items[0]?.memberUuid })
            results.dynamDBMembersData = res
        }

        return results
    }

    return (
        <div className={'container '}>
            <p className='title'>Members ( {data?.count || 0} )</p>
            <p className="sub-title">Member details from Health rules</p>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1rem 1rem 0rem', }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', width: '100%', flexWrap: 'wrap', }}>
                    {/* <ReactJson
                        style={{ padding: "1rem" }}
                        src={selectedAccounts}
                        name={false}
                        collapsed={false}
                        collapseStringsAfterLength={150}
                        displayDataTypes={false}
                        displayObjectSize={false}
                        sortKeys={false}
                    /> */}
                    {selectedAccounts?.map((account, i) => {
                        return <AsyncPaginate
                            key={i}
                            placeholder={`Select ${i ? ' sub account' : 'an account'}`}
                            className="react-select-container large-input"
                            classNamePrefix={"react-select"}
                            debounceTimeout={300}
                            value={selectedAccounts[i]}
                            //  cacheUniqs={[i]}
                            clearCacheOnMenuClose={true}
                            clearCacheOnSearchChange={true}
                            isSearchable={true}
                            loadOptions={loadAccounts} //{i ? loadAccounts : loadAccountHccIdentificationNumber}
                            onChange={v => {
                                let newArray
                                if (!v) {
                                    if (!i) {
                                        newArray = [null]
                                    } else {
                                        newArray = [...selectedAccounts.slice(0, i), null]
                                    }
                                }

                                else {
                                    if (!i) {
                                        newArray = [v];
                                        if (v?.additional?.subAccountsCount) {
                                            newArray.push(null)
                                        }
                                    } else {
                                        newArray = [
                                            ...selectedAccounts.slice(0, i),
                                            v,
                                            ...selectedAccounts.slice(i)
                                        ];
                                        if (!v?.additional?.subAccountsCount) {
                                            newArray.splice(newArray.length - 1, 1)
                                        }

                                    }
                                }
                                setSelectedAccounts(newArray)
                            }}

                            styles={customStyles}
                            isClearable={true}
                            additional={{
                                includeSubAccounts: 'Y',
                                accountLevel: (selectedAccounts?.[i - 1]?.additional?.accountLevel || 0) + i ? 1 : 0,
                                parentAccountKey: selectedAccounts?.[i - 1]?.additional?.parentAccountKey
                            }}
                        />
                    })}

                    {/* <AsyncPaginate
                        placeholder={"Select top account"}
                        className="react-select-container large-input"
                        classNamePrefix={"react-select"}
                        debounceTimeout={300}
                        value={topAccount}
                        isSearchable={false}
                        loadOptions={loadAccounts}
                        onChange={setTopAccount}
                        styles={customStyles}
                        isClearable
                    />

                    {topAccount?.additional?.subAccountsCount &&
                        <AsyncPaginate
                            placeholder={"Select a sub account"}
                            className="react-select-container large-input"
                            classNamePrefix={"react-select"}
                            debounceTimeout={300}
                            value={selectedSubAccounts[0]}
                            isSearchable={false}
                            loadOptions={loadAccounts}
                            onChange={v => setSelectedSubAccounts([v])}
                            styles={customStyles}
                            isClearable={true}
                            additional={{
                                accountLevel: 1,
                                parentAccountKey: topAccount?.additional?.parentAccountKey
                            }}
                        />

                    } */}
                    <Select
                        name={'searchBy'}
                        className="react-select-container large-input"
                        classNamePrefix="react-select"
                        placeholder={'Search by'}
                        // inputRef={field.ref}
                        options={searchOptions}
                        value={searchBy} // Pass the state variable here
                        onChange={(option) => { setSearchBy(option) }}
                    // value={options.find((c) => c.value === field.value)}
                    // onChange={(val) => field.onChange(val.value)}
                    />

                    {searchBy && <input
                        style={{ fontSize: "1rem", minWidth: "250px", padding: "1rem", borderRadius: ".4rem", border: "1px solid var(--lighterGrey)", outline: "none" }}
                        type="text"
                        id={"search"}
                        placeholder="search..."
                        // list="items"
                        autoComplete="off"
                        // onFocus={() => setCurrentPage(0)}
                        onChange={(e) => {
                            setSearchValue(e.target.value);
                            debouncedChangeHandler(e);
                        }}
                        value={searchValue}
                    />}

                </div>
            </div>

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0rem 1rem 1rem 0rem" }}>
                <p
                    style={{ cursor: "pointer", color: "var(--red)" }}
                    onClick={() => {
                        setSearchBy(null)
                        setDecouncedSearchValue("");
                        setSearchValue("");
                        setSelectedAccounts([null])
                    }}
                >
                    Clear filters
                </p>

                <p style={{ cursor: "pointer", color: "var(--green)" }} onClick={() => setShowMoreColumns(!showMoreColumns)}>
                    {showMoreColumns ? "Less Columns" : "More Columns"}
                </p>

            </div>


            {
                status === "loading" ? (
                    <p>Loading...</p>
                ) : status === "error" ? (
                    <span className='danger'>Error: {error.message}</span>
                ) : (
                    <>
                        <SharedTable
                            type={"members"}
                            columns={columns}
                            items={data?.rows}
                            activeDraftId={null}
                            hasNextPage={hasNextPage}
                            isFetchingNextPage={isFetchingNextPage}
                            fetchNextPage={fetchNextPage}
                            isFetching={isFetching}
                            isLoading={isLoading}
                            // onEditHandler={onEditHandler}
                            //   onDetailHandler={onDetailHandler}
                            disableModel={true}
                            onDetailHandler={async (body) => body?.memberHccId && window.open(`/members/${body?.memberHccId}`, '_blank', 'noopener,noreferrer')
                                // && await navigate(body?.memberHccId)
                            }
                            ref={ref}
                        />
                    </>
                )
            }

        </div >
    )
}


export default Members